import client from './client';
import { unwrapData } from './response';

export const listAppointments = async (params = {}) => {
  const response = await client.get('/appointments', { params });
  return unwrapData(response);
};

export const getAppointment = async (id) => {
  const response = await client.get(`/appointments/${id}`);
  return unwrapData(response, null);
};

export const createAppointment = async (payload) => {
  const response = await client.post('/appointments', payload);
  return unwrapData(response, null);
};

export const updateAppointment = async (id, payload) => {
  const response = await client.patch(`/appointments/${id}`, payload);
  return unwrapData(response, null);
};

export const cancelAppointment = async (id, payload = {}) => {
  const response = await client.post(`/appointments/${id}/cancel`, payload);
  return unwrapData(response, null);
};

export const rescheduleAppointment = async (id, payload) => {
  const response = await client.post(`/appointments/${id}/reschedule`, payload);
  return unwrapData(response, null);
};

export const markAppointmentCompleted = async (id) => {
  return updateAppointment(id, { status: 'completed' });
};
